/**
 * Centralized authentication state management
 * Tracks logout state to prevent API calls after logout
 *
 * ⚠️ DEPRECATED: This file now acts as a compatibility layer.
 * New code should use useAuthStore() from '@/domains/auth/store/authStore' directly.
 * This wrapper is kept for backward compatibility.
 */

import {
  getAuthStoreSafe,
  shouldPreventApiCallSafe,
  isAuthLoggedOutSafe,
} from '@/shared/utils/piniaSafe.util';

/**
 * Mark user as logged out
 * Should be called immediately when logout process starts
 */
export function markAsLoggedOut() {
  const authStore = getAuthStoreSafe();
  authStore?.markAsLoggedOut();
}

/**
 * Mark user as logged in
 * Should be called when user successfully logs in
 */
export function markAsLoggedIn() {
  const authStore = getAuthStoreSafe();
  authStore?.markAsLoggedIn();
}

/**
 * Check if user is logged out
 * @returns {boolean} True if user has logged out
 */
export function isUserLoggedOut() {
  return isAuthLoggedOutSafe();
}

/**
 * Check if an error should be suppressed (expected after logout)
 * @param {Error} error - The error to check
 * @param {Object} router - Vue router instance (optional)
 * @returns {boolean} True if error should be suppressed
 */
export function shouldSuppressError(error, router = null) {
  const authStore = getAuthStoreSafe();
  if (!authStore) return false;
  return authStore.shouldSuppressError(error, router);
}

/**
 * Check if API call should be prevented (user logged out)
 * @returns {boolean} True if API calls should be prevented
 */
export function shouldPreventApiCall() {
  return shouldPreventApiCallSafe();
}
